/** @format */

import BotItem from "./BotItem";
import styles from "../../../styles/Components/new-dashboard/bot-performance/BotLists.module.css";
import { BsPlusCircle } from "react-icons/bs";
import { MdMoreHoriz } from "react-icons/md";
import useUserBotList from "./hooks/useUserBotList";
import { useState } from "react";
import MoreBotsModal from "./MoreBotsModal";

function BotLists() {
  const {
    otherBots,
    inactiveBots,
    otherCoinNum,
    activeBotNum,
    activeBots,
    visibilityNumberBots,
  } = useUserBotList();

  const [selectedModalBot, setSelectedModalBot] = useState(() => {
    return JSON.parse(localStorage.getItem("selectedDashboardBot")) || null;
  });
  const [showMoreBotsModal, setShowMoreBotsModal] = useState(false);

  const handleOpenMoreModal = () => {
    setShowMoreBotsModal(true);
  };

  const handleBotSelect = (bot) => {
    setSelectedModalBot(bot);
    // Save selected bot to localStorage
    localStorage.setItem("selectedDashboardBot", JSON.stringify(bot));
    setShowMoreBotsModal(false);
  };

  return (
    <div className={styles.container}>
      <h6 className={styles.title}>Bots</h6>
      <div className={styles.botList}>
        {!!activeBotNum &&
          activeBots
            ?.slice(0, visibilityNumberBots)
            .map((bot, i) => (
              <BotItem key={`${bot?.bot_creation_id}/${i}`} data={bot} />
            ))}
        {/*{activeBotNum >=4 ? activeBots?.slice(0, 4).map((bot, i) => <BotItem  key={`${bot?.bot_creation_id}/${i}`} data={bot} />) : activeBot ? <BotItem data={activeBot}/> : ""}*/}
        {/*{activeBot && <BotItem data={activeBot} />}*/}
        {activeBotNum !== visibilityNumberBots &&
          otherBots?.map((bot, i) => (
            <BotItem data={bot} key={`${bot?.bot_creation_id}/${i}`} />
          ))}

        {selectedModalBot && (
          <BotItem
            data={selectedModalBot}
            key={`selected-${selectedModalBot?.bot_creation_id}`}
          />
        )}

        {inactiveBots?.length > otherCoinNum && (
          <BotItem type="seeMore" onClick={handleOpenMoreModal}>
            <MdMoreHoriz size={22} />
            <p>View More</p>
          </BotItem>
        )}
      </div>

      {showMoreBotsModal && (
        <MoreBotsModal
          show={showMoreBotsModal}
          setShow={setShowMoreBotsModal}
          onSelectBot={handleBotSelect}
          selectedBot={selectedModalBot}
        />
      )}
    </div>
  );
}

export default BotLists;
